import React from 'react';
import { PasswordInputProps } from '../../types/Forms/PasswordInput';
import { EyeClosed, EyeSolid } from 'iconoir-react';

export const PasswordInput = (props: PasswordInputProps) => {
  const [hidden, setHidden] = React.useState(true);
  const passInput = document.getElementById(props.id);
  const handleClick = () => {
    if (!passInput) return;
    const type = passInput.getAttribute('type') === 'password' ? 'text' : 'password';
    setHidden(!hidden);
    passInput.setAttribute('type', type);
  };
  return (
    <div className="relative mb-4">
      <label htmlFor="password" className="text-black-800 block text-xl font-bold font-medium">
        {props.title}:
      </label>
      <div className="flex items-center">
        <input
          type="password"
          id={props.id}
          placeholder="Password"
          required
          name="password"
          value={props.password}
          onChange={props.onChange}
          className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
        />
        <button type="button" id="togglePassword" className="-ml-8 focus:outline-hidden" onClick={handleClick}>
          {hidden ? <EyeClosed color="gray" strokeWidth={0.5} /> : <EyeSolid color="gray" strokeWidth={0.5} />}
        </button>
      </div>
    </div>
  );
};
